import type { RegisterInitRequest } from "@/services/api";
import type { RegistrationFormValues } from "../types";

export const mapToRegisterRequest = (data: RegistrationFormValues): RegisterInitRequest => ({
  username: data.phoneNumber,
  email: data.email,
  phoneNumber: data.phoneNumber,
  password: data.password,
  firstName: data.firstName,
  lastName: data.lastName,
});
